// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1Iknw","validationTips":"StatementDescriptor_validationTips__3Qbqg"};